import { Component, input, output } from '@angular/core';
import {
  ButtonComponent,
  ButtonSeverity,
  ButtonSize,
} from '../../ui/button/button';
import { Arrow } from '../../icons/arrow/arrow';
import { Chip } from 'primeng/chip';

@Component({
  standalone: true,
  selector: 'app-page',
  imports: [
    ButtonComponent,
    Arrow,
    Chip,
  ],
  templateUrl: './page.html',
  styleUrl: './page.scss',
})
export class PageComponent {
  flush = input<boolean>(false);
  pageTitle = input<string>('');
  pageDescription = input<string>('');
  actionLabel = input<string>('');
  statusChipLabel = input<string>();
  statusChipClass = input<string>();
  secondaryActionLabel = input<string>();
  thirdActionLabel = input<string>();
  backLabel = input<string>();
  showMenuIcon = input<boolean>(false);
  showAvatar = input<boolean>(false);
  showDivider = input<boolean>(false);
  imageUrl = input<string>();

  onHandleAction = output<void>();
  onHandleSecondAction = output<void>();
  onHandleThirdAction = output<void>();
  backClicked = output<void>();
  menuIconClicked = output<void>();

  handleAction() {
    this.onHandleAction.emit();
  }

  handleActionSecondary() {
    this.onHandleSecondAction.emit();
  }

  handleActionThird() {
    this.onHandleThirdAction.emit();
  }

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;
}
